'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$70() {
  this.bGN = null;
  this.bGO = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$70 as $c_Lpresto_TwoFactorAuthView$$anon$70 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$70;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$70() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$70 as $h_Lpresto_TwoFactorAuthView$$anon$70 };
$h_Lpresto_TwoFactorAuthView$$anon$70.prototype = $p;
$p.P = (function() {
  if ((!this.bGO)) {
    this.bGN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bGO = true;
  }
  return this.bGN;
});
var $d_Lpresto_TwoFactorAuthView$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$70, "presto.TwoFactorAuthView$$anon$70", ({
  Tb: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$70 as $d_Lpresto_TwoFactorAuthView$$anon$70 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$70.js.map
